import React, { useEffect, useState } from "react";
import { Button, message, Modal } from "antd";
import { lib } from "../index";
import copy from "copy-to-clipboard";

export default function InviteCustomerUser() {
    let [visible, setVisible] = useState(false);
    let [inviteLink, setInviteLink] = useState("");
    let [inviteVo, setInviteVo] = useState();
    useEffect(() => {
        if (visible) {
            lib.request({
                url: "/ucenter-customer/user/sub/invite",
                needMask: true,
                success: res => {
                    setInviteVo(res);
                    setInviteLink(
                        `https://${location.host}/login/register?type=3&join=${res?.join}&name=${encodeURIComponent(
                            res?.name,
                        )}`,
                    );
                },
            });
        }
    }, [visible]);
    const copyInviteLink = () => {
        copy(`邀请你加入 ${inviteVo?.name}，请点击此链接 ${inviteLink} 加入企业`);
        message.success("复制成功");
    };
    return (
        <>
            {visible && (
                <Modal
                    open={true}
                    title="邀请员工"
                    maskClosable={false}
                    onCancel={() => setVisible(false)}
                    onOk={() => {
                        setVisible(false);
                    }}
                    footer={[<Button onClick={() => setVisible(false)}>稍后邀请</Button>]}>
                    <div className={"invite-modal-content"}>
                        <span>大家可以通过点击你的分享链接加入企业</span>
                        <div className={"invite-modal-content-card"}>
                            <div className={"text"}>
                                邀请你加入{inviteVo?.name}，请点击此链接{" "}
                                <a href={inviteLink} target={"_blank"}>
                                    {decodeURIComponent(inviteLink)}
                                </a>
                            </div>
                            <Button type={"primary"} onClick={() => copyInviteLink()}>
                                复制
                            </Button>
                        </div>
                    </div>
                </Modal>
            )}
            <Button type={"primary"} onClick={() => setVisible(true)}>
                邀请员工
            </Button>
        </>
    );
}
